import { ASSIGNMENT_TYPES } from "@/schemas/structure-assignment";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";
import { useMemo } from "react";

const KAM_2_CSD_SUBORDINATE_ROLES = [
  SYSTEM_ROLE_CODE.KEY_ACCOUNT_MANAGER,
  SYSTEM_ROLE_CODE.LEASING_OUTSOURCING,
  SYSTEM_ROLE_CODE.CKM_LEAD,
] as const;

export const useSubordinateRole = (assignmentType?: string) =>
  useMemo(() => {
    switch (assignmentType) {
      case ASSIGNMENT_TYPES.RR_2_RD:
        return SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE;
      case ASSIGNMENT_TYPES.RR_2_FAM:
        return SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE;
      case ASSIGNMENT_TYPES.KAM_2_CSD:
        return [...KAM_2_CSD_SUBORDINATE_ROLES];
      default:
        return undefined;
    }
  }, [assignmentType]);
